import React from 'react';
import { useSelector } from 'react-redux';
import { getPlayerDuelState } from '../store/selectors/playerDuelSelector';
import GameContextPlayerDuel from '../GameContextPlayerDuel';

const GameContextPlayerDuelDataContainer = (props) => {
    const playerDuelState = useSelector(getPlayerDuelState);

    return (
        <GameContextPlayerDuel { ...playerDuelState } { ...props } />
    );
};

export default GameContextPlayerDuelDataContainer;
